import { useState } from 'react';
import { DateRange } from '@material-ui/icons';
import { DashboardCardTimespan } from '../../types/commonTypes';
import { timespans } from '../../lib/constants';
import { Menu, MenuItem } from '../Menu';
import { Button } from '../Button/NewButton';

interface Props {
  dateRange: DashboardCardTimespan;
  onDateChange(item: any): void;
}

export const DateRangeSelector = ({ dateRange, onDateChange }: Props) => {
  const [anchorEl, setAnchorEl] = useState<any | null>();

  const openTimespan = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const closeTimespan = () => {
    setAnchorEl(null);
  };

  const changeTimespan = (event: any) => {
    onDateChange(timespans[event.target.value]);
    setAnchorEl(null);
  };

  return (
    <div className="flex m-1">
      <Button
        className="!bg-transparent !text-inherit hover:opacity-70"
        aria-owns={anchorEl ? 'dash_timespan' : undefined}
        aria-haspopup="true"
        onClick={openTimespan}
        startIcon={<DateRange fontSize="small" color="inherit" />}
        padding="sm"
      >
        {dateRange ? dateRange.name : ''}
      </Button>

      <Menu
        id="dash_timespan"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeTimespan}
        placement="top-start"
      >
        {timespans.map((ts, key) => (
          <MenuItem
            key={key}
            value={key}
            onClick={changeTimespan}
            disabled={ts === dateRange}
          >
            {ts.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
